<template>
<div>
    <div id="header-wrapper">
			<div class="header">
				<h1>Breadcrumbs</h1>
			</div>
		</div>
    <!--Content-->
		<div id="content">
      <div class="types">
        <h2>Types</h2>
        <h3>Icon separator</h3>

        <h2>Style</h2>
        <h3>Colors</h3>
        <div class="left mt--bg--neutrals-light-gray-01 height250">
          <img :src="colors" alt="">
        </div>
        <div class="right mt-font--body10 height198">
          <p>Default text: #485464</p>
          <p>Hover text: #055AFE</p>
          <p>Active text: #004AD4</p>
        </div>
        <h3>Sizing</h3>
        <div class="left mt--bg--neutrals-light-gray-01 height250">
          <img :src="sizing" alt="">
        </div>
        <div class="right mt-font--body10 height198">
          <p>Font size: 14px</p>
          <p>Horizontal padding: 5px</p>
        </div>
      </div>
		</div>

  </div>
</template>

<script>
export default {
  name: '',
  props: [],
  components: {

  },
  data () {
    return {
      sizing: require('@/assets/breadcrumbs-style-sizing.svg'),
      colors: require('@/assets/breadcrumbs-style-colors.svg'),
    }
  },
  computed: {

  },

  methods: {

  },

  
}
</script>


// WEBPACK FOOTER //
// Breadcrumbs.vue?50ace12e